export const UPLOAD_COD_REMITTANCE_REQUEST = "UPLOAD_COD_REMITTANCE_REQUEST";
export const UPLOAD_COD_REMITTANCE_SUCCESS = "UPLOAD_COD_REMITTANCE_SUCCESS";
export const UPLOAD_COD_REMITTANCE_FAILURE = "UPLOAD_COD_REMITTANCE_FAILURE";
export const uploadCodRemittanceSuccess = (payload) => ({
    type: UPLOAD_COD_REMITTANCE_SUCCESS,
    payload,
});
export const uploadCodRemittanceRequest = (payload) => ({
    type: UPLOAD_COD_REMITTANCE_REQUEST,
    payload,
});
export const uploadCodRemittanceFailure = (payload) => ({
    type: UPLOAD_COD_REMITTANCE_FAILURE,
    payload,
});
